// Left navigation rail (components/Sidebar.tsx).

export const sidebarTestIds = {
  sidebar: 'sidebar-nav-panel',
  nav: 'sidebar-nav',
  brandLink: 'sidebar-brand-link',
  workspaceName: 'sidebar-workspace-name',
  collapseButton: 'sidebar-collapse-button',
  groupLabel: (label: string) => `sidebar-group-${label.toLowerCase()}-label` as const,
  link: (label: string) => `sidebar-${label.toLowerCase().replace(/\s+/g, '-')}-link` as const,
  expandButton: (label: string) => `sidebar-${label.toLowerCase().replace(/\s+/g, '-')}-expand-button` as const,
  count: (label: string) => `sidebar-${label.toLowerCase().replace(/\s+/g, '-')}-count` as const,
  userButton: 'sidebar-user-button',
  orgName: 'sidebar-org-name',
  /** "Your first integration" pill above the account card; opens the setup checklist. */
  setupPillButton: 'sidebar-setup-pill-button',
  setupPillCount: 'sidebar-setup-pill-count',
} as const;
